module.exports = __webpack_public_path__ + "h5assets/img/start-edition-sales@3x.d47ec1f.png";